import { motion, AnimatePresence } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';

import { Advt } from './components/Advt/Advt';
import { MessagesList } from './components/MessagesList/MessagesList';

import logo from './assets/images/logo.png';

function App() {
  const { showedMessages, speed, currentState } = useCarousel();

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={logo}
        alt=""
        className="logo"
      />

      <AnimatePresence mode="wait">
        {Boolean(currentState) && (
          <motion.div
            key={Boolean(currentState)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ y: '100vh' }}
            transition={{ duration: 0.5 }}
            className="motionBlock"
          >
            <Advt />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        className="motionBlock"
        initial={{ y: '100vh' }}
        animate={{ y: currentState === 'S2' ? '0' : '100vh' }}
        exit={{ y: '100vh' }}
        transition={{ duration: 0.5 }}
        style={{ zIndex: 15 }}
      >
        <MessagesList
          messages={showedMessages}
          currentState={currentState}
          speed={speed || 0}
        />
      </motion.div>
    </div>
  );
}

export default App;
